<div class="container">
  <div class="contact-widget">
    <div class="wrap wrapClose">
      <button type="button" class="close" (click)="cancel()">Close</button>
    </div>
    <ng-container *ngIf="!contactUpdateService.policyAdminDown">
      <div class="wrap wrapHead">
        <div class="pageHead">
          <h1>Update contact information</h1>
          <div class="subhead">{{ headerText }}</div>
        </div>
      </div>
      <contact-update #owner [contactInfo]="ownerContactInfo" [childMode]="false"></contact-update>
      <contact-update
        *ngIf="!sameOwnerInsured"
        #insured
        [contactInfo]="insuredContactInfo"
        [childMode]="true"
        (sameAddressChange)="isSameAddress($event)"
      ></contact-update>
      <div class="wrap wrapFoot">
        <div class="cta">
          <button type="submit" class="btnSubmit" [disabled]="isDisabled()" (click)="updateContact()">Submit</button>
          <button type="button" class="btnCancel" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </ng-container>
  </div>
  <policy-admin-down *ngIf="contactUpdateService.policyAdminDown" [helpEmail]="helpEmail"></policy-admin-down>
  <widget-modal *ngIf="showModal" (showModal)="closeModal()" [dismiss]="dismiss"></widget-modal>
</div>
